<template>
  <section>
    <QrcodeDialog ref="qrcodeDialog" />
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-radio-group v-model="tableData.chooseRadio">
          <el-table
            v-loading="tableData.loading"
            ref="multipleTable"
            :data="tableData.data"
            tooltip-effect="dark"
            @select="handleSelectionChange"
            @select-all="handleSelectionChange"
          >
            <!-- 选择框 -->
            <el-table-column
              v-if="!isRadio"
              type="selection"
              :selectable="checkSelectable"
              width="55"
            />
            <!-- 选择框 end -->
            <el-table-column v-if="isRadio" width="55" label="选择">
              <template slot-scope="scope">
                <el-radio :label="scope.row[tableData.selectTar]"
                  >&nbsp;</el-radio
                >
              </template>
            </el-table-column>
            <!-- 常规列表项 -->
            <el-table-column
              v-for="(item, index, key) in tableData.title"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
            />
          </el-table>
        </el-radio-group>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="left">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </section>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  deductList,
} from 'api/cost';
import QrcodeDialog from 'components/qrcodeDialog';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    QrcodeDialog,
  },
  props: {
    isRadio: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectTar: 'LId',
        chooseRadio: '', // 单选选择
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'appDate',
            label: '借支时间',
          },
          {
            prop: 'amount',
            label: '金额',
          },
          {
            prop: 'payedAmount',
            label: '已核销',
          },
          {
            prop: 'canDeductedAmount',
            label: '可抵扣',
          },
          {
            prop: 'deductedAmount',
            label: '抵扣中',
          },
          {
            prop: 'currentRecordDeductedAmount',
            label: '本业务抵扣中',
          },
          {
            prop: 'loanSubjectName',
            label: '借支类型',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: deductList,
    checkSelectable (row) {
      // 可抵扣金额为 0 时不可选择
      return Number(row.canDeductedAmount) !== 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
